module.exports = __webpack_public_path__ + "static/media/face.fc4fa5ac.png";